module.exports = __webpack_public_path__ + "img/shiba-loading.dc9bf254.png";